import React from 'react'
import classes from './SectionHero.module.scss';
import renderHTML from 'react-render-html';
import { getFileName } from 'helpers/FileCaching';
const backgroundImages = require.context('../../../images/components/SectionHero/backgroundimage', true, /.*\.(gif|png|jpe?g|svg)$/i);

function SectionHero({content, windowSize, anchorName}){
        let overlay;
  
        const showOverlay = content.overlayBgImage;
    
        if(showOverlay !== '' && showOverlay === 'true'){
            overlay = <div className={`overlay_titles_bottom`}></div>
        }

	return (
        <div id={anchorName} className={classes.section_hero}>
                <div className={`container-fluid`} style={{padding: 0}}>
                        <div className={classes.section_hero__bgImage} 
                                style={{backgroundImage: `url(${getFileName(backgroundImages, content.bgImage[windowSize])})`}}
                                title={content.imgTitle}
                        >
                               {overlay}
                                <div className={classes.section_hero__header}>
                                        <div className={`row`}  style={{margin: 0}}>
                                                <div className={`${classes.section_hero__content}`}>
                                                        <p className={`subtitle_white_global ${classes.section_hero__subtitle}`}>{renderHTML(content.subtitle)}</p> 
                                                         <h3 className={classes.section_hero__title}>{renderHTML(content.title)}</h3>
                                                         <div className={`divider_white ${classes.section_hero__divider}`}></div>
                                                        <p className={classes.section_hero__desc}>{renderHTML(content.description)}</p>
                                                </div>  
                                        </div>
                                
                                </div>

                        </div>
                   
                </div>
        </div>
	)
}

export default SectionHero